import React, { useState } from 'react';
import './quizList.scss';
import moment from 'moment-timezone';
import _ from 'lodash';
import { Link } from 'gatsby';
import { questions1, questions2, questions3 } from './quizData';
import { home_gifts } from '../../../../HomePage/DesktopHome/desktopData';
import QuizSuccess from './QuizSuccess';
import GiftHat from './GiftHat';
import CopyBtn from '../copyBtn/copyBtn';
export default function QuizList() {
  // let Selectday = moment.tz(new Date(), 'Europe/Berlin').format('D');
  let Selectday = '24';
  const [clicked, setClicked] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [score, setScore] = useState(0);
  const [test, setTest] = useState([0, 0, 0]);
  const [responseMessage, setMessage] = useState(null);
  let imgBack = home_gifts.slice(1, 5);
  const [toggle, setToggle] = useState(false);
  const [firsButton, setFirstButton] = useState(false);
  const [secondButton, setSecondButton] = useState(false);
  const handleAnswerOptionClick = (isCorrect, key) => {
    //quiz botton checkout
    if (key === 0) {
      setFirstButton(true);
    }
    if (key === 1) {
      setSecondButton(true);
    }
    setClicked(true);
    if (isCorrect) {
      setScore(score + 1);
      test[currentQuestion] = 1;
    } else {
      setScore(score + 1);
      test[currentQuestion] = 2;
    }

    const nextQuestion = currentQuestion + 1;
    let quizLength =
      Selectday === '5'
        ? questions1.length
        : Selectday === '12'
        ? questions2.length
        : Selectday === '19'
        ? questions3.length
        : '';
    if (nextQuestion < quizLength) {
      setTimeout(() => {
        setCurrentQuestion(nextQuestion);
        setClicked(false);
        setSecondButton(false);
        setFirstButton(false);
      }, 2000);
    } else {
      setTimeout(() => {
        setShowScore(true);
      }, 2000);
    }
  };

  const Indicator = () => {
    const arr = [];
    let quizLength =
      Selectday === '5' ? questions1 : Selectday === '12' ? questions2 : Selectday === '19' ? questions3 : '';
    for (let i = 0; i <= quizLength.length - 1; i++) {
      let width = 100 / quizLength.length + 1 - 2;
      arr.push(
        <div
          key={i}
          className="indicator"
          style={
            test[i] === 0
              ? { background: '#c4c4c4', width: width + `%` }
              : test[i] === 1
              ? { backgroundColor: '#12aa56', width: width + `%` }
              : { backgroundColor: '#981E2F', width: width + `%` }
          }
        ></div>,
      );
    }
    return arr;
  };

  const [addToCart, setAddToCard] = useState(false);
  let AddToCard = (data) => {
    if (data) {
      setAddToCard(true);
    }
  };

  const [copySuccess, setCopySuccess] = useState('');

  let copyToClipBoard = () => {
    setCopySuccess('Kopiert!');
  };

  const [codeList, setCodeList] = useState({
    code: [
      { day: '19', code: '8PN3CGKH7J7H' },
      { day: '24', code: '8ER3HMB1X9F0QUIZ' },
    ],
  });

  return (
    <React.Fragment>
      {Selectday === '24' ? (
        <>
          <div className="quizAnswer">
            {test[0] === 2 && test[1] === 2 && test[2] === 2 ? (
              <>
                <div className="quizIndicator">{Indicator()}</div>
                <div className="quizSorry">
                  <p>
                    Es tut uns Leid <br />
                  </p>
                </div>
                <div className="quiz-small">
                  {' '}
                  <p>Wir haben jeden Tag eine Aktion. Besuchen Sie uns morgen wieder</p>
                </div>
                <div style={{ marginBottom: '40px' }}>
                  <Link to="https://www.gobicashmere.com/collections/holiday" className="quiz-link">
                    <p>Weiter zum Shop</p>
                  </Link>
                </div>
              </>
            ) : addToCart === false ? (
              <GiftHat handle={'rippmutze-1'} AddToCard={AddToCard} />
            ) : (
              <>
                <div className="hat-container">
                  <div className="shipp-title">
                    <p> Herzlichen Glückwunsch! </p>
                    <span> Ab einem Bestellwert von 150 EUR erhalten Sie das von Ihnen ausgewählte Produkt.</span>
                  </div>
                  <CopyBtn
                    copyToClipBoard={copyToClipBoard}
                    copySuccess={copySuccess}
                    codeList={codeList}
                    Selectday={Selectday}
                  />
                  <div style={{ marginTop: '18px' }}></div>
                  <Link to="https://www.gobicashmere.com/de/collections/holiday" className="shipp-btn">
                    Weiter zum Shop
                  </Link>
                  <div style={{ marginBottom: '47px' }}></div>
                </div>
              </>
            )}
          </div>
        </>
      ) : (
        <div className="quizAnswer">
          <div className="quizIndicator">{Indicator()}</div>
          <div className="quizAsuult">
            <h3>
              {test[currentQuestion] === 0 ? (
                Selectday === '5' ? (
                  questions1[currentQuestion].questionText
                ) : Selectday === '12' ? (
                  questions2[currentQuestion].questionText
                ) : Selectday === '19' ? (
                  questions3[currentQuestion].questionText
                ) : (
                  ''
                )
              ) : test[currentQuestion] == 2 ? (
                <span style={{ color: '#981E2F' }}>Incorrect !</span>
              ) : (
                <span style={{ color: '#629D45' }}>Success !</span>
              )}
            </h3>
          </div>
          <div className="quizHariult">
            {Selectday === '5' ? (
              <>
                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${firsButton ? questions1[currentQuestion].answerOptions[0].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions1[currentQuestion].answerOptions[0].isCorrect,
                      questions1[currentQuestion].answerOptions[0].key,
                    )
                  }
                >
                  <span className="quizText">{questions1[currentQuestion].answerOptions[0].answerText}</span>
                </button>

                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${secondButton ? questions1[currentQuestion].answerOptions[1].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions1[currentQuestion].answerOptions[1].isCorrect,
                      questions1[currentQuestion].answerOptions[1].key,
                    )
                  }
                >
                  <span className="quizText">{questions1[currentQuestion].answerOptions[1].answerText}</span>
                </button>
              </>
            ) : Selectday === '12' ? (
              <>
                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${firsButton ? questions2[currentQuestion].answerOptions[0].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions2[currentQuestion].answerOptions[0].isCorrect,
                      questions2[currentQuestion].answerOptions[0].key,
                    )
                  }
                >
                  <span className="quizText">{questions2[currentQuestion].answerOptions[0].answerText}</span>
                </button>

                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${secondButton ? questions2[currentQuestion].answerOptions[1].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions2[currentQuestion].answerOptions[1].isCorrect,
                      questions2[currentQuestion].answerOptions[1].key,
                    )
                  }
                >
                  <span className="quizText">{questions2[currentQuestion].answerOptions[1].answerText}</span>
                </button>
              </>
            ) : Selectday === '19' ? (
              <>
                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${firsButton ? questions3[currentQuestion].answerOptions[0].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions3[currentQuestion].answerOptions[0].isCorrect,
                      questions3[currentQuestion].answerOptions[0].key,
                    )
                  }
                >
                  <span className="quizText">{questions3[currentQuestion].answerOptions[0].answerText}</span>
                </button>

                <button
                  // @ts-ignore
                  disabled={clicked === true ? 'true' : ''}
                  className={`quizButton ${secondButton ? questions3[currentQuestion].answerOptions[1].color : ''} ${
                    clicked ? '' : 'hoverButton'
                  }`}
                  onClick={() =>
                    handleAnswerOptionClick(
                      questions3[currentQuestion].answerOptions[1].isCorrect,
                      questions3[currentQuestion].answerOptions[1].key,
                    )
                  }
                >
                  <span className="quizText">{questions3[currentQuestion].answerOptions[1].answerText}</span>
                </button>
              </>
            ) : (
              ''
            )}
          </div>
        </div>
      )}
    </React.Fragment>
  );
}
